import React from 'react';
import { Grid, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const DurationSelector = ({ durationValue, durationUnit, onDurationChange }) => {

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        // Allow empty string or positive numbers
        if (newValue === '' || (!isNaN(newValue) && Number(newValue) >= 0)) {
            onDurationChange({ value: newValue, unit: durationUnit });
        }
    };

    const handleUnitChange = (event) => {
        onDurationChange({ value: durationValue, unit: event.target.value });
    };

    return (
        <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={6} sm={8}>
                <TextField
                    label="Duration Value"
                    type="number"
                    fullWidth
                    value={durationValue}
                    onChange={handleValueChange}
                    inputProps={{ min: "0" }} // Prevent negative numbers directly in input
                    required // Add required if needed at this level
                />
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormControl fullWidth>
                    <InputLabel id="duration-unit-label">Unit</InputLabel>
                    <Select
                        labelId="duration-unit-label"
                        value={durationUnit}
                        label="Unit"
                        onChange={handleUnitChange}
                        required // Add required if needed at this level
                    >
                        <MenuItem value="days">Days</MenuItem>
                        <MenuItem value="weeks">Weeks</MenuItem>
                        <MenuItem value="months">Months</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default DurationSelector;